
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem9Grid extends Serenity.EntityGrid<PsAdvPromoItem9Row, any> {
        protected getColumnsKey() { return PsAdvPromoItem9Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem9Dialog; }
        protected getIdProperty() { return PsAdvPromoItem9Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem9Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem9Row.localTextPrefix; }
        protected getService() { return PsAdvPromoItem9Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}